import "../style.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { IEditReportState, IReportCountriesIndicators, IRestorationPledgeTrackingDetailsTab } from "../models/IEditReportState";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-datepicker/dist/react-datepicker.css";
import Select, { MultiValue } from "react-select";
import LoadingOverlay from 'react-loading-overlay';
import QueryService from "../../../../shared/queryService";
import ConfigService from "../../../../shared/configService";
import { IGADM_0 } from '.../../../src/models/IConfig';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import {
 // IRefPledgeEcosystemTypeFeature,
  //IRefPledgeInitiativeFeature,
  IRefActionIndicatorFeature,
  IRefImpactIndicatorFeature,
  IRefLocationSpecificFeature,
  IRefCountriesFeature
} from "../models/IRefFeature";
import { IFeature } from "@esri/arcgis-rest-types";
import { ToastContainer, toast } from "react-toastify";
import Utils from "../../../../shared/utils";

const SectorRestorationPledgeDetails = (props: {
  state: IEditReportState;
  setState: Function;
  validateData: Function;
}) => {
  const { t } = useTranslation("sectorreports");

  /**
   * Local state
   */
  interface ILocalState {
    reportLayerIndex: number;
   // importReportDisabled: boolean;
    //refPledgeInitiativeFeature: IRefPledgeInitiativeFeature[];
    //refPledgeEcosystemTypeFeature: IRefPledgeEcosystemTypeFeature[];
    //otherInitiativeInputEnabled: boolean;
    //otherEcosystemInputEnabled: boolean;
    //anteriorReport?: IReportMainFeature;
    refActionIndicatorFeature: IRefActionIndicatorFeature[];
    refImpactIndicatorFeature: IRefImpactIndicatorFeature[];
    locationSpecificFeature: IRefLocationSpecificFeature[];
    countriesList: IRefCountriesFeature[];
    privateSectorReportCountriesIndicators:IReportCountriesIndicators[];
    isFetchingReportData: false,

  }
  const [localState, setTheLocalState] = useState<ILocalState>({
    reportLayerIndex:
      ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
   // importReportDisabled: true,
    //refPledgeInitiativeFeature: [],
    refActionIndicatorFeature: [],
    refImpactIndicatorFeature: [],
    //refPledgeEcosystemTypeFeature: [],
    // otherInitiativeInputEnabled: getOtherInitiativeInputEnabled(
    //   props.state.restorationPledgeTab?.linked_init || ""
    // ),
    // otherEcosystemInputEnabled: getOtherEcosystemInputEnabled(
    //   props.state.restorationPledgeTab?.ecosystems || ""
    // ),
    locationSpecificFeature: [],
    countriesList: [],
    privateSectorReportCountriesIndicators:[],
    isFetchingReportData: false,
  });
  const [isNewRow, setIsNewRow] = useState(false);
  //const [isDelRow, setIsDelRow] = useState(false);
  const [isDelRow, setIsDelRow] = useState<boolean>(false); 
  // Use effect
  useEffect(() => {
    setIsDelRow(false);
    //Reference table
    getRefFeatures();
    
  },[]);

  /**
   * Set fetching report data loading on / off
   * @param loading
   */
  const setFetchingReportDataLoading = (loading: boolean) => {
    const obj: any = { ...localState };

    if (obj) {
      obj.isFetchingReportData = loading;
      setTheLocalState(obj);
    }
  }
  /**
   * Set parent state
   * @param prop
   * @param value
   */
  const setParentState = async (prop: string, value: any,idx:number) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state };
      const subObj: IRestorationPledgeTrackingDetailsTab = {
        ...obj.restorationPledgeTrackingDetailsTab,
      } as IRestorationPledgeTrackingDetailsTab;

      (subObj as any)[prop] = value;

      let countryId = await getSelectedCountryId(value);
      
      // To fix the issue -"Action & Impact - Data should be cleared after changing the question in Pledge Implementation Tracking Details yes to No (After saving draft). Currently data is still displayed.
      if (prop === "location_specific") 
      {
        if(obj.restorationPledgeTrackingDetailsTab!.location_specific==="1")
        {
          subObj.action_indicators='';
          subObj.impact_indicators='5'; 
          obj.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators=[];         
        }
        else 
        {
          obj.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators=[];
          const item = {
            isActive: true,
            isOK: false,
            OBJECTID: -1,
            report_id: '',
            country_indicator: '',
            country_id: '',
            action_indicator: '',
            impact_indicator: '5',
          };
          obj.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators!.push(item);
        }
      }
      // // If ecosystem, set RB ha_intervention_types
      if (prop === "country_indicator") {
        obj.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators?.forEach(
          (i: IReportCountriesIndicators,j:number) => {

            //Validation of duplicate data in action-impact indicator table
            let countryName = i.country_indicator;            
            
            if(countryName != '')
            {       
              if(countryName == value)
              {
                value = '';
                toast.error(t('newReport.restorationPledgeDetails.countryAlreadyExists'));
                return;
              } 
            }  

            if(j===idx)
            {
              i.country_indicator = value;            
              i.country_id = countryId.toString();
            }
          }
        );
      }
      if (prop === "action_indicator") {
        obj.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators?.forEach(
          (i: IReportCountriesIndicators,j:number) => {
            if(j===idx)
            {
              i.action_indicator = value;
            }
          }
        );
      }
      if (prop === "impact_indicator") {
        obj.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators?.forEach(
          (i: IReportCountriesIndicators,j:number) => {
            if(j===idx)
            {
              i.impact_indicator = value;
            }
          }
        );
      }

      // Check isOK
      props.validateData(subObj);

      obj.restorationPledgeTrackingDetailsTab = subObj;

      props.setState(obj);
    }
  };

  const getSelectedCountryId = async (countryName: any) => {
    const where = `${gadm0Config.fields.name0} = '${countryName}'`
    const countryFeature = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm0Config.index), where, true, '*', '', null, false);
    const gid0: string[] = countryFeature.map((feat: IFeature) => feat.attributes[gadm0Config.fields.gid0]).filter((value, index, self) => (value != null && self.indexOf(value) === index));

    return Promise.resolve(gid0);
    //return gid0;
  }

  const handleActionChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('action_indicators', val,0);
  }

  const handleImpactChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('impact_indicators', val,0);
  }

  const handleCountryActionChange = (items:any,idx:number) => {
      const val: string = items && items.length ? items.map((i: { value: any; }) => i.value).join(',') : '';
      setParentState('action_indicator', val,idx);
    }

  const handleCountryImpactChange = (items:any,idx:number) => {
    const val: string = items && items.length ? items.map((i: { value: any; }) => i.value).join(',') : '';
    setParentState('impact_indicator', val,idx);
  }

  /**
   * Get reference list
   */
  const getRefFeatures = async () => {
    setFetchingReportDataLoading(true);
    const fields =
      ConfigService.getConfig().agol.operationalLayers.reportMain.fields;
    
      const locSpecificFeature = [
        { key_: '1', value: t("newReport.restorationPledgeDetails.Yes") },
        { key_: '0', value: t("newReport.restorationPledgeDetails.No") }
      ];

    const impactFilter = "1=1";
    const IndicatorFeature = await QueryService.queryFilterReferenceFeatures(
      Utils.getReferenceTableQuery(
        ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.index
      ),
      impactFilter,
      false,
      "*",
      ``
    );
    const actionFeature: IFeature[] = IndicatorFeature
    .filter( (feat: IFeature) => {
      return feat.attributes[ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.fields.indicatortype] ==="Action";
    })

    const impactFeature: IFeature[] = IndicatorFeature
    .filter( (feat: IFeature) => {
      return feat.attributes[ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.fields.indicatortype] ==="Impact";
    })

    const obj: ILocalState = { ...localState };
    obj.locationSpecificFeature = locSpecificFeature;

    //actionFeature;
    obj.refActionIndicatorFeature = actionFeature.map(
      (feat: IFeature) => feat.attributes as IRefActionIndicatorFeature
    );

    //impactFeature;
    obj.refImpactIndicatorFeature = impactFeature.map(
      (feat: IFeature) => feat.attributes as IRefActionIndicatorFeature
    );

    const countryFeature = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm0Config.index), '', true, '*', '', null, false);

    obj.countriesList = countryFeature.map(
      (feat: IFeature) => feat.attributes as IRefCountriesFeature
    );
    obj.privateSectorReportCountriesIndicators=props.state.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators;
    setFetchingReportDataLoading(false);
    setTheLocalState(obj);

    // Validate data
    setValidState();
    
  };

  /**
   * Set valid state
   */
  const setValidState = () => {
    const obj2: IEditReportState = { ...props.state };
    const subObj: IRestorationPledgeTrackingDetailsTab = {
      ...obj2.restorationPledgeTrackingDetailsTab,
    } as IRestorationPledgeTrackingDetailsTab;

    if (subObj) {
      props.validateData(subObj);
    }

    obj2.restorationPledgeTrackingDetailsTab = subObj;
    props.setState(obj2);
  };

  /**
   * Check if a field is required
   * @param field
   */
  const isRequired = (field: string): boolean => {
    return Utils.isRequiredField(
      ConfigService.getConfig().agol.operationalLayers.reportMain.requiredFields
        .restorationPledge,
      field
    );
  };
  const gadm0Config: IGADM_0 = ConfigService.getConfig().agol.gadmLayers.gadm_0;

  const handleAddRow = async () => {
    setIsNewRow(false); 
    var returnData = await validateIndicatorMapping();
    if (returnData === true) {
      const item = {
        isActive: true,
        isOK: false,
        OBJECTID: -1,
        report_id: '',
        country_indicator: '',
        country_id: '',
        action_indicator: '',
        impact_indicator: '5',
      };
      props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators!.push(item);
      setIsNewRow(true);          
    }
  };
  const handleRemoveSpecificRow = async (idx: number) => {
    setIsDelRow(false);
    if (idx !== -1) {
      props.state.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators?.splice(idx, 1);
    }
    setIsDelRow(true);

    let items: any;
    handleCountryActionChange(items,-1);
  }
  const validateIndicatorMapping = async () => {
    let resultVal: any = true;
    const relatedData = props.state.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators!;
    relatedData.forEach((id: any) => {
      if (id.country_indicator === undefined || (id.impact_indicator === "" || id.impact_indicator === undefined)) {
        toast.error(t('newReport.resultsAndBenefits.validationError'));
        resultVal = false;
      }
    });
    return resultVal;
  }

  return (
    <div className="oneTabContent restorationPledgeDetailsTab">
      <span className="bigText">
        {t("newReport.restorationPledgeDetails.label")}
      </span>

      <div className="separtorDiv"></div>

      <div className="row">
        <span className="titleSpan mediumText">
          13. {t("newReport.restorationPledgeDetails.locationSpecificData")}
        </span>
        <span className="titleSpan mediumText co2SequesteredFormula marginbtm10">
          {t("newReport.restorationPledgeDetails.locationSpecificDataDesc")}
        </span>
        <div className="col-2 singleDDLDiv">
          <select className="mediumText"
            value={props.state.restorationPledgeTrackingDetailsTab?.location_specific || '-999'}
            onChange={(e) => { setParentState('location_specific', e.target.value,0) }}>
            {/* {<option value="-999" key=""></option>} */}
            {localState.locationSpecificFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
          </select>
        </div>
      </div>
      <div>
      <span className="titleSpan mediumText">14. {t('newReport.restorationPledgeDetails.eightindicatorstypes')}
      <strong>{t('newReport.restorationPledgeDetails.indicatortypesSplit1')}</strong>
      {t('newReport.restorationPledgeDetails.indicatortypesSplit2')}
      <strong>{t('newReport.restorationPledgeDetails.indicatortypesSplit3')}</strong>
      {t('newReport.restorationPledgeDetails.indicatortypesSplit4')}</span>
      </div>
      {props.state.restorationPledgeTrackingDetailsTab?.location_specific === '1' &&
        <>
          <div>
            <table className="table table-bordered table-hover" id="tab_logic">
              <thead>
                <tr>
                  <th className="text-center"> </th>
                  <th className="text-center">Country </th>
                  <th className="text-center"> {t('newReport.restorationPledgeDetails.actionIndicatorExport')} </th>
                  <th className="text-center"> {t('newReport.restorationPledgeDetails.impactIndicatorsExport')}</th>
                  <th className="text-center">  </th>
                </tr>
              </thead>
              <tbody>
              {props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators?.map((p:IReportCountriesIndicators, idx: any) =>
              <>
                <tr id="addr" className="col-md-12" key={idx}>
                  <td id="indexID" className="tdindexID">{idx + 1}</td>
                  <td className="singleDDLDiv width100">
                    <select className="mediumText"
                      value={p.country_indicator || ''}
                      onChange={(e) => { setParentState('country_indicator', e.target.value,idx) }}>
                      {<option value="" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                      {localState.countriesList.map((i) => <option value={i.NAME_0} key={i.GID_0}>{i.NAME_0}</option>)}
                    </select>
                  </td>
                  <td className="col-md-4">
                    <Select
                      classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
                      closeMenuOnSelect={true} isMulti
                      options={localState.refActionIndicatorFeature.map((i: IRefActionIndicatorFeature) => { return { label: i.value, value: i.key_ } })}
                      onChange={(e) =>handleCountryActionChange(e,idx)}
                      value={
                        localState.refActionIndicatorFeature.map((i: IRefActionIndicatorFeature) => { return { label: i.value, value: i.key_ } })
                          .filter(option => (p.action_indicator || '').split(',').indexOf(option.value || 'Select') !== -1)
                      } />
                  </td>
                  <td className="col-md-4 firstDdlDisable">
                    <Select
                      classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
                      closeMenuOnSelect={true} isMulti
                      options={localState.refImpactIndicatorFeature.map((i: IRefImpactIndicatorFeature) => { return { label: i.value, value: i.key_ } })}
                      onChange={(e) =>handleCountryImpactChange(e,idx)}
                      value={
                        localState.refImpactIndicatorFeature.map((i: IRefImpactIndicatorFeature) => { return { label: i.value, value: i.key_ } })
                          .filter(option => (p.impact_indicator || '').split(',').indexOf(option.value || 'Select') !== -1)
                      } />
                  </td>
                  <td className="width5">
                  <FontAwesomeIcon className="tabIcon deleteIcon" icon={faTrash} onClick={() => { handleRemoveSpecificRow(idx) }} />
                  </td>
                </tr>
                </>
              )}
              </tbody>
            </table>
            {(props.state.generalInfoTab?.ps_report_type !== '' && props.state.generalInfoTab?.ps_report_type !== '1') &&
            <button className="createNewBtn primary" onClick={() => handleAddRow()}>
              <span className="editSpan">{t('addNew')}</span>&nbsp; &nbsp;
              <FontAwesomeIcon className="plusIcon" icon={faPlus} />
            </button>
            }
          </div>
        </>
      }
      {props.state.restorationPledgeTrackingDetailsTab?.location_specific !=='1' &&
        <>
          <div className="row">
            {/* <span className="titleSpan mediumText">
              {t("newReport.restorationPledgeDetails.eightindicatorstypes")}
            </span> */}
            <span className="titleSpan mediumText">
              {t("newReport.restorationPledgeDetails.actionIndicators")}
            </span>
            <div className="col-10">
              <Select
                classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
                closeMenuOnSelect={true} isMulti
                options={localState.refActionIndicatorFeature.map((i: IRefActionIndicatorFeature) => { return { label: i.value, value: i.key_ } })}
                onChange={handleActionChange}
                value={
                  localState.refActionIndicatorFeature.map((i: IRefActionIndicatorFeature) => { return { label: i.value, value: i.key_ } })
                    .filter(option => (props.state.restorationPledgeTrackingDetailsTab?.action_indicators || '').split(',').indexOf(option.value || 'Select') !== -1)
                } />
            </div>


          </div>
          <div className="row">
            <span className="titleSpan mediumText">
              {t("newReport.restorationPledgeDetails.impactIndicators")}
            </span>
            <div className="col-10 firstDdlDisable">
              <Select
                classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
                closeMenuOnSelect={true} isMulti
                options={localState.refImpactIndicatorFeature.map((i: IRefImpactIndicatorFeature) => { return { label: i.value, value: i.key_ } })}
                onChange={handleImpactChange}
                value={
                  localState.refImpactIndicatorFeature.map((i: IRefImpactIndicatorFeature) => { return { label: i.value, value: i.key_ } })
                    .filter(option => (props.state.restorationPledgeTrackingDetailsTab?.impact_indicators || '').split(',').indexOf(option.value || 'Select') !== -1)
                } />
            </div>

          </div>
        </>
      }
      <LoadingOverlay
        active={localState.isFetchingReportData}
        spinner
        text={localState.isFetchingReportData ? t('newReport.fetchingReportData') : ''}>
      </LoadingOverlay>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default SectorRestorationPledgeDetails;
